import Dexie from 'dexie';

export const db = new Dexie('CueMeUpDB');

// console.log('db', db);
db.version(2).stores({
  routes: 'id, name, description, tag_list, cached_at',
  settings: 'id',
  auth: 'id, rwgps'
});

db.version(3).stores({
  routes: 'id, routeJson, trackPointsWithPoi, chartSettings, cachedAt',
  settings: 'id',
  auth: 'id, rwgps'
});

db.version(4).stores({
  routes: 'id, routeJson, trackPointsWithPoi, chartSettings, cachedAt',
  settings: 'id',
  auth: 'id, rwgps',
  surveyStatus: 'id, lastSurveyDate'
});